import { Star } from "lucide-react";
import { FadeUp, MaskLine } from "./Reveal";

const TESTIMONIALS = [
  {
    name: "R. Meenakshi",
    location: "Madurai",
    stars: 5,
    text: "The decoction smells exactly like the coffee from my grandmother's house. Mornings feel complete again.",
  },
  {
    name: "Suresh Kumar",
    location: "Coimbatore",
    stars: 5,
    text: "We serve TMV filter coffee at our tea shop. Customers notice the difference and keep coming back.",
  },
  {
    name: "Anitha Raghavan",
    location: "Chennai",
    stars: 4,
    text: "Ordered the premium tea for home. Fresh, strong and full of flavour — and the delivery was quick too.",
  },
];

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="bg-cream py-24 text-espresso md:py-32">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <div className="mb-14">
        <FadeUp>
          <p className="mb-5 text-[11px] uppercase tracking-widest2 text-caramel">Kind Words</p>
        </FadeUp>
        <h2 className="font-display text-4xl leading-tight sm:text-5xl">
          <MaskLine delay={0.05}>What our people</MaskLine>
          <MaskLine delay={0.18} className="italic text-caramel">
            say over coffee.
          </MaskLine>
        </h2>
      </div>

      <div className="grid gap-6 md:grid-cols-3 md:gap-8">
        {TESTIMONIALS.map((t, i) => (
          <FadeUp key={t.name} delay={i * 0.1}>
            <figure
              data-testid={`testimonial-card-${i + 1}`}
              className="flex h-full flex-col justify-between rounded-sm border border-espresso/10 bg-offwhite-none p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(18,14,13,0.25)]"
              style={{ background: "#FAF6EE" }}
            >
              <div>
                <div className="flex gap-1" data-testid={`testimonial-stars-${i + 1}`} aria-label={`${t.stars} star rating`}>
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star
                      key={s}
                      size={15}
                      className={s <= t.stars ? "fill-caramel text-caramel" : "text-espresso/20"}
                    />
                  ))}
                </div>
                <blockquote className="mt-5 font-display text-lg italic leading-relaxed text-espresso/85">
                  “{t.text}”
                </blockquote>
              </div>
              <figcaption className="mt-7 border-t border-espresso/10 pt-5">
                <p className="text-sm font-semibold tracking-wide">{t.name}</p>
                <p className="mt-0.5 text-xs uppercase tracking-[0.15em] text-espresso/50">
                  {t.location}
                </p>
              </figcaption>
            </figure>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
